import { Mail, Phone } from 'lucide-react';

/** A person's email and phone as links — readable, not tucked away as muted meta. */
export function ContactDetails({ email, phone }: { email?: string | null; phone?: string | null }) {
	if (!email && !phone) return null;
	return (
		<div className="flex min-w-0 flex-wrap items-center gap-x-4 gap-y-1 text-sm text-text-2">
			{phone && (
				<a
					href={`tel:${phone.replace(/\s+/g, '')}`}
					className="inline-flex items-center gap-1.5 transition-colors hover:text-accent"
				>
					<Phone size={13} className="shrink-0 text-text-4" />
					{phone}
				</a>
			)}
			{email && (
				<a
					href={`mailto:${email}`}
					className="inline-flex min-w-0 items-center gap-1.5 transition-colors hover:text-accent"
				>
					<Mail size={13} className="shrink-0 text-text-4" />
					<span className="truncate">{email}</span>
				</a>
			)}
		</div>
	);
}
